module.exports = __webpack_public_path__ + "static/images/flag-indonesia.3H51vW7.svg";